import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  Link,
  useLocation,
} from 'react-router-dom';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import * as VseSession from '../features/session';

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    flex: 1,
    padding: theme.spacing(1, 1),
  },
  paper: {
    margin: 'auto',
    padding: theme.spacing(2),
  },
}));

export function Timeout() {
  const theme = useTheme();
  const classes = useStyles(theme);
  const dispatch = useDispatch();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const url = params.get("redirect");
  let loginLink = '/login';
  if (url) {
    loginLink += `?redirect=${url}`;
  }

  React.useEffect(() => {
    return () => {
      dispatch(VseSession.reset());
    }
  }, [dispatch]);

  return (
    <main className={classes.main}>
      <Paper className={classes.paper}>
        <Typography variant='h6'>Timeout</Typography>
        <Typography variant='body1'>Your login session has been timeout, <Link to={loginLink}>please login and try again</Link>.</Typography>
      </Paper>
    </main>
  );
}
